/**
 * Equipment Health Summary Component
 * 
 * A placeholder component that displays the Equipment Health Summary section.
 * This component is designed to be expanded in the future with API data integration.
 */

import React from 'react';
import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Alert from '@amzn/meridian/alert';
import Text from '@amzn/meridian/text';

export interface EquipmentHealthSummaryProps {
  /** Site identifier for future API integration */
  site?: string;
  /** APM ID for future API integration */
  apmId?: string;
}

/**
 * EquipmentHealthSummary component that displays placeholder content
 * for future equipment health data integration
 */
export const EquipmentHealthSummary: React.FC<EquipmentHealthSummaryProps> = ({
  site,
  apmId
}) => {
  return (
    <Card width={"50%"}>
      <Column spacing="400" spacingInset="400">
        <Heading level={4}>Equipment Health Summary</Heading>
        <Alert type="neutral">
          {/* Once the API done, need to update this. */}
          <Text>Equipment health analytics and recommendations will be available here.</Text>
        </Alert>
      </Column>
    </Card>
  );
};
